import { IGraphQlConnection } from 'types/core.types';
import { IPartnerRequest } from '../../Partner/types/partner.types';
import { IBaseDocument } from '../../Document/types/document.types';

export enum ImpactClaimStatus {
  'CREATED' = 'CREATED',
  'UPDATED' = 'UPDATED',
  'REQUESTED' = 'REQUESTED',
  'APPROVED' = 'APPROVED',
  'DENIED' = 'DENIED',
  'ARCHIVED' = 'ARCHIVED',
  'DELETED' = 'DELETED',
}

export interface ImpactClaimCreateInput {
  impactCatalogItemId: string;
  attachments: string[];
  productId?: string;
  componentId?: string;
  assignedToId?: string;
  status?: ImpactClaimStatus;
  requestIds: string[];
}
export interface ICreateImpactClaimPayload {
  createImpactClaim: {
    impactClaim: ImpactClaim;
  };
}

interface ImpactClaimProductSummary {
  id: string;
  title: string;
  publicUrl: string;
}

interface ImpactClaimCompanySummary {
  id: string;
  name: string;
}

export interface ImpactClaim {
  id: string;
  impactCatalogItem: ImpactCatalogItem;
  createdTimestamp: Date;
  status: ImpactClaimStatus;
  product?: ImpactClaimProductSummary;
  assignedTo?: ImpactClaimCompanySummary;
  createdBy: ImpactClaimCompanySummary;
  attachments: IGraphQlConnection<IBaseDocument>;
  attachmentCount: number;
  PartnerRequests: IGraphQlConnection<IPartnerRequest>;
  logs: ImpactClaimLog[];

  // Type policies
  impactLevel: 'BUSINESS' | 'PRODUCT' | 'PARTNER';
  impactLevelTitle?: string;
  isPending: boolean;
  isApproved: boolean;
  isInvalid: boolean;
}

export interface ImpactClaimLog {
  comment: string | null;
  timestamp: Date;
  action: ImpactClaimStatus;
  user: {
    email: string;
    firstName: string;
    lastName: string;
  };
}

export interface ImpactCatalogItem {
  id: string;
  title: string;
  definition: string;
  category: ImpactCatalogCategory;
  types: ImpactCatalogItemType[];
  links: string[];
  thirdParties: string[];
  iconUrl?: string;
  sustainableDevGoals: ISustainableDevGoal[];
  acceptanceCriteria: ImpactCatalogItemAcceptanceCriteria[];
  docRequirements: ImpactCatalogItemDocRequirement[];
}

interface ImpactCatalogCategory {
  id: string;
  title: string;
  type: ImpactCatalogCategoryType;
}

export enum ImpactCatalogCategoryType {
  'SOCIAL' = 'SOCIAL',
  'ECOLOGICAL' = 'ECOLOGICAL',
}

enum ImpactCatalogItemType {
  'CLAIM' = 'CLAIM',
  'PROOF_POINT' = 'PROOF_POINT',
}

interface ISustainableDevGoal {
  id: string;
  number: number;
  title: string;
  description: string;
  color: string;
  iconUrl: string;
}

export interface ImpactCatalogItemAcceptanceCriteria {
  id: string;
  description: string;
}

export interface ImpactCatalogItemDocRequirement {
  id: string;
  description: string;
}
export interface ImpactCatalogItemRequest {
  id: string;
  userId: string;
  title: string;
  description?: string;
  createdTimestamp: Date;
}

export enum EDisclaimerTarget {
  'SELECT_CLAIM_SLIDE' = 'SELECT_CLAIM_SLIDE',
  'REQUEST_CLAIM_DIALOG' = 'REQUEST_CLAIM_DIALOG',
}
